module.exports = __webpack_public_path__ + "img/b-drive.5476c419.png";